export default "__VITE_ASSET__D8LnB7qw__"